/** 图形验证码获取冷却（毫秒）：上一次获取完成后至少等 2s 才能再次获取 */
export const CAPTCHA_REFRESH_COOLDOWN_MS = 2000

/**
 * 包装图形验证码获取函数：
 * - 请求进行中忽略重复触发（防并发连续点击）
 * - 上一次完成后冷却期内（默认 2s）忽略再次获取
 * @param {() => Promise<any>} fetcher 实际获取验证码的异步函数（保留原 this 与参数）
 */
export function createCaptchaRefresher(fetcher) {
  let inFlight = false
  let lastDoneAt = 0
  return async function throttledCaptchaRefresh(...args) {
    if (inFlight) return
    if (Date.now() - lastDoneAt < CAPTCHA_REFRESH_COOLDOWN_MS) return
    inFlight = true
    try {
      return await fetcher.apply(this, args)
    } finally {
      inFlight = false
      lastDoneAt = Date.now()
    }
  }
}
